import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tag,
  message,
  Descriptions,
  Button,
  Table,
  Tabs,
  Spin,
  Typography,
  Avatar,
} from "antd";
import { useParams, Link } from "react-router-dom";
import {
  UserOutlined,
  CarOutlined,
  FileTextOutlined,
  ArrowRightOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;

const OwnerDetail = () => {
  const { id } = useParams();
  const [ownerData, setOwnerData] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState({
    idAttachment: null,
    imageAttachment: null,
  });

  useEffect(() => {
    fetchOwnerDetails();
  }, []);

  const fetchOwnerDetails = async () => {
    try {
      setLoading(true);
      const ownerResponse = await axios.get(`http://93.127.203.113:5005/owners/${id}`);
      setOwnerData(ownerResponse.data);
      setVehicles(ownerResponse.data.vehicles || []);
    } catch (error) {
      message.error("Failed to load owner details.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (fieldName, file) => {
    setSelectedFiles((prevState) => ({
      ...prevState,
      [fieldName]: file,
    }));
  };

  const handleUpload = async (fieldName) => {
    const file = selectedFiles[fieldName];
    if (!file) {
      message.error("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append(fieldName, file);

    try {
      setUploading(true);
      await axios.put(
        `http://93.127.203.113:5005/owners/${id}/upload`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      message.success(
        `${fieldName === "idAttachment" ? "ID Attachment" : "Owner Image"} updated successfully!`
      );
      fetchOwnerDetails();
    } catch (error) {
      message.error("Failed to upload file.");
    } finally {
      setUploading(false);
      setSelectedFiles((prevState) => ({
        ...prevState,
        [fieldName]: null,
      }));
    }
  };

  const vehicleColumns = [
    { title: "Plate Number", dataIndex: "plateNumber", key: "plateNumber" },
    { title: "Model", dataIndex: "model", key: "model" },
    { title: "Color", dataIndex: "color", key: "color" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>
          {status ? status.toUpperCase() : "UNKNOWN"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button type="link" style={{ color: "#0c8c49" }}>
          Details
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "5px solid #0c8c49",
          }}
        >
          <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
            Owner Details
          </Title>
          <Tabs defaultActiveKey="1" type="card">
            <TabPane
              tab={
                <span>
                  <UserOutlined /> Owner Information
                </span>
              }
              key="1"
            >
              <Row gutter={[24, 24]}>
                <Col span={24} md={12}>
                  <Card
                    title="Owner Profile"
                    bordered={false}
                    extra={
                      ownerData?.id && (
                        <Link to={`/ownerDetails/${ownerData.id}`}>
                          <Button type="link" style={{ color: "#0c8c49" }}>
                            View Full Profile
                          </Button>
                        </Link>
                      )
                    }
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                      {ownerData?.imageAttachment ? (
                        <img
                          src={`http://93.127.203.113:5005${ownerData.imageAttachment}`}
                          alt="Owner"
                          style={{
                            width: "150px",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "50%",
                            border: "2px solid #ddd",
                          }}
                        />
                      ) : (
                        <Avatar
                          shape="square"
                          icon={<UserOutlined />}
                          style={{
                            width: "150px",
                            height: "150px",
                            backgroundColor: "#f0f2f5",
                          }}
                        />
                      )}
                    </div>
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Name">
                        {ownerData?.name || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Contact">
                        {ownerData?.contact || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Email">
                        {ownerData?.email || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Address">
                        {ownerData?.address || "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>

                <Col span={24} md={12}>
                  <Card
                    title="ID Attachment"
                    bordered={false}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                      {ownerData?.idAttachment ? (
                        <img
                          src={`http://93.127.203.113:5005${ownerData.idAttachment}`}
                          alt="ID"
                          style={{
                            width: "100%",
                            maxHeight: "200px",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <p style={{ color: "#999" }}>No ID Attachment Available</p>
                      )}
                    </div>
                  </Card>
                </Col>
              </Row>
            </TabPane>

            <TabPane
              tab={
                <span>
                  <CarOutlined /> Owned Vehicles
                </span>
              }
              key="2"
            >
              <Card
                title="Vehicles"
                bordered={false}
                style={{
                  borderRadius: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Table columns={vehicleColumns} dataSource={vehicles} rowKey="id" />
              </Card>
            </TabPane>
          </Tabs>
        </Card>
      )}
    </div>
  );
};

export default OwnerDetail;
